'use client'

import React, { useCallback, useEffect, useRef } from 'react'

interface Props {
  children: React.ReactElement
  onClickOutside?: (e: MouseEvent) => void
}

export const ClickOutsideDetector = ({ children, onClickOutside }: Props) => {
  const wrapper = useRef<HTMLDivElement>(null)
  const onClickScreen = useCallback(
    (e: MouseEvent) => {
      if (
        !e.target ||
        !(e.target instanceof Node) ||
        !wrapper.current?.contains(e.target)
      ) {
        // 특정 element 외의 영역 클릭
        onClickOutside?.(e)
      }
    },
    [children],
  )

  useEffect(() => {
    window.addEventListener('mousedown', onClickScreen, { passive: true })

    return () => {
      window.removeEventListener('mousedown', onClickScreen)
    }
  }, [onClickScreen])

  return (
    <div ref={wrapper} style={{ display: 'contents' }}>
      {children}
    </div>
  )
}
